import { useIsRevenueCatAvailable } from '@/src/modules/pricing/hooks/useIsRevenueCatAvailable';
import useQueryRevenueCatOfferings from '@/src/modules/pricing/queries/useQueryRevenueCatOfferings';
import createFakeRevenueCatOfferingFromPlan from '@/src/modules/pricing/utils/createFakeRevenueCatOfferingFromPricing';
import { getPlanByOfferingId } from '@fabric-app/business/pricing/pricing.utils';
import type { PurchasesOffering } from '@revenuecat/purchases-capacitor';
import { useMemo } from 'react';

const useQueryRevenueCatOffering = (
  offeringId?: string,
): { data: PurchasesOffering | undefined | null; isLoading: boolean } => {
  const { data, isLoading } = useQueryRevenueCatOfferings();
  const isRevenueCatAvailable = useIsRevenueCatAvailable();

  return useMemo(() => {
    if (!offeringId) {
      return {
        data: undefined,
        isLoading: false,
      };
    }

    if (!isRevenueCatAvailable) {
      const plan = getPlanByOfferingId(offeringId);
      const offering = plan ? createFakeRevenueCatOfferingFromPlan(offeringId, plan) : null;
      return {
        data: offering,
        isLoading: false,
      };
    }

    if (data && data.all[offeringId]) {
      const offering = data?.all[offeringId];
      return {
        data: offering,
        isLoading: false,
      };
    }

    return {
      data: undefined,
      isLoading,
    };
  }, [data, isLoading, offeringId, isRevenueCatAvailable]);
};

export default useQueryRevenueCatOffering;
